import { createFileRoute } from '@tanstack/react-router';

import { ResearchCenterBrowse } from '@/module/ResearchCenter';

export const Route = createFileRoute('/_auth/research-center/_research-center/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <ResearchCenterBrowse />;
}
